define(function (require, exports, module) {
    'use strict';

    var countries = require('./countries');
    var regions = require('./regions');

    // @ngInject
    exports.lpUserPlaces = function() {
        return {
            regions: regions,
            countries: countries
        };
    };
});



/*****************
 ** WEBPACK FOOTER
 ** ./scripts/data/places.js
 ** module id = 9
 ** module chunks = 0
 **/